module.exports = __webpack_public_path__ + "static/media/logo-white.5f8c4263.svg";